import Image from "next/image";
import { MdOutlineClose } from "react-icons/md";

export function BackgroundContainer({
  title,
  children,
  onClose,
  backgroundImage,
}: {
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  backgroundImage?: string;
}) {
  return (
    <>
      {!!backgroundImage && (
        <>
          <Image
            alt="background"
            src={backgroundImage}
            fill
            className="md:block hidden absolute top-0 left-0 -z-10"
          />
          
          <div className="absolute md:block hidden -z-10 top-0 left-0 w-full h-full bg-secondary-color/60" />
        </>
      )}
      <div className="h-[100dvh] md:h-[95dvh] w-screen max-w-lg fixed  md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 top-0 md:border-4 md:border-primary-color md:rounded-2xl md:!w-[480px]">
        {!!onClose && (
          <button
            onClick={onClose}
            className="absolute -top-1 -right-16 z-50 text-xl font-bold bg-white border-2 border-primary-color rounded-full p-1 hidden md:block"
          >
            <MdOutlineClose size={20} />
          </button>
        )}
        {!!title && (
          <div className="flex flex-col w-full max-w-lg absolute top-0 z-50">
            <div className="z-[9999] flex items-center justify-between w-full h-16 pt-2 mb-1 bg-gradient-to-b from-black md:rounded-2xl">
              <div className="w-[10%]"></div>
              <h2 className="text-sm font-bold text-center text-white uppercase w3/5">
                {title}
              </h2>
              <button
                onClick={onClose}
                className="w-[10%] text-xl font-bold text-right text-white md:invisible"
              >
                <MdOutlineClose size={24} />
              </button>
            </div>
          </div>
        )}
        {children}
      </div>
    </>
  );
}
